import React, { useState } from 'react';
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import { styled } from '@mui/material/styles';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import CloseIcon from '@mui/icons-material/Close';
import ContactModal from './ContactModal';

const StyledSpeedDial = styled(SpeedDial)(({ theme }) => ({
  position: 'fixed',
  bottom: 32,
  right: 32,
  '& .MuiFab-primary': {
    backgroundColor: '#1A365D',
    '&:hover': {
      backgroundColor: '#2A4A7F',
    },
  },
}));

const FloatingContact = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSpeedDialOpen, setIsSpeedDialOpen] = useState(false);

  const handleWhatsAppClick = () => {
    // Numéro WhatsApp avec le code pays (exemple pour la France)
    const phoneNumber = '+33600000000'; // Remplacer par votre numéro
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleEmailClick = () => {
    setIsModalOpen(true);
    setIsSpeedDialOpen(false);
  };

  const actions = [
    { icon: <WhatsAppIcon />, name: 'WhatsApp', onClick: handleWhatsAppClick },
    { icon: <EmailIcon />, name: 'Email', onClick: handleEmailClick },
  ];

  return (
    <>
      <StyledSpeedDial
        ariaLabel="Contact SpeedDial"
        icon={<SpeedDialIcon openIcon={<CloseIcon />} />}
        open={isSpeedDialOpen}
        direction="up"
        onClose={() => {}}
        onOpen={() => {}}
        onClick={() => setIsSpeedDialOpen(!isSpeedDialOpen)}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={action.onClick}
            FabProps={{
              sx: {
                bgcolor: '#1A365D',
                '&:hover': {
                  bgcolor: '#2A4A7F',
                },
                color: 'white',
              }
            }}
          />
        ))}
      </StyledSpeedDial>

      <ContactModal 
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default FloatingContact;
